module.exports = __webpack_public_path__ + "img/grk2.43f73a70.png";